import { render, staticRenderFns } from "./AllowanceMeter.vue?vue&type=template&id=453bcf9e&scoped=true"
import script from "./AllowanceMeter.vue?vue&type=script&lang=js"
export * from "./AllowanceMeter.vue?vue&type=script&lang=js"
import style0 from "./AllowanceMeter.vue?vue&type=style&index=0&id=453bcf9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453bcf9e",
  null
  
)

export default component.exports